import styled from "styled-components/native";
import { View, Pressable } from "react-native";
import { space } from "styled-system";

export const StyledView = styled(View)(space);

export const StyledPressable = styled(Pressable)`
  align-self: flex-start;
`;
